import { Body } from "./Body";
import { Button } from "./Button";
import { Popover } from "./Popover";

export const MediaSettingPopover = Object.assign(Popover, {
  Body,
  Button,
});
